// extracted by mini-css-extract-plugin
module.exports = {"text-input":"TextInput_text-input__3Jvi_"};